import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AviationEvent } from '../../shared/models/aviation-event.model';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { AviationEventsService } from '../../shared/services/aviation-events.service';

@Component({
  selector: 'app-edit-event-features',
  templateUrl: './edit-event-features.component.html',
  styleUrls: ['./edit-event-features.component.scss']
})
export class EditEventFeaturesComponent implements OnInit {
  formGroup: FormGroup;
  aviationEvent: AviationEvent;
  isLoading = true;

  constructor(private _matDialogRef: MatDialogRef<EditEventFeaturesComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _aviationEventsService: AviationEventsService,
              private _fb: FormBuilder,
              private _snackBar: MatSnackBar) {
    this.aviationEvent = data.aviationEvent;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this._matDialogRef.close(null);
    });

    const isValidated = this.aviationEvent.isValidated;
    const isFeatured = this.aviationEvent.isFeatured ? this.aviationEvent.isFeatured : false;
    const hasAopaPresence = this.aviationEvent.hasAopaPresence ? this.aviationEvent.hasAopaPresence : false;
    const isAopaHosted = this.aviationEvent.isAopaHosted ? this.aviationEvent.isAopaHosted : false;

    this.formGroup = this._fb.group({
      isValidated: [this.aviationEvent.isValidated, Validators.nullValidator],
      isFeatured: [this.aviationEvent.isFeatured, Validators.nullValidator],
      hasAopaPresence: [this.aviationEvent.hasAopaPresence, Validators.nullValidator],
      isAopaHosted: [this.aviationEvent.isAopaHosted, Validators.nullValidator]
    }, {updateOn: 'submit'});

    this.isLoading = false;
  }

  close(result = {cancelBtnClicked: true, success: false}) {
    if (result) {
      this._matDialogRef.close(result);
    }
  }

  cancel() {
    this._matDialogRef.close(null);
  }

  async save () {
    const TEMP_aviationEvent = this.aviationEvent;

    if (this.formGroup.invalid) {
      this._snackBar.open('Form field validation failed. check form values', null, {duration: 5000});
      return;
    }

    this.aviationEvent.isValidated = this.formGroup.value.isValidated || false;
    this.aviationEvent.isFeatured = this.formGroup.value.isFeatured || false;
    this.aviationEvent.hasAopaPresence = this.formGroup.value.hasAopaPresence || false;
    this.aviationEvent.isAopaHosted = this.formGroup.value.isAopaHosted || false;

    // make api call
    try {
      await this._aviationEventsService.updateAviationEvent(this.aviationEvent);
      this.close({cancelBtnClicked: false, success: true});
    } catch (e) {
      this.aviationEvent = TEMP_aviationEvent;
      this.close({cancelBtnClicked: false, success: false});
    }
  }

}
